package com.tovtalk.ui.components

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.tovtalk.ui.platform.TovTalkVideoPlayer

/**
 * TovTalkReelPlayer - Optimized for full-screen vertical videos (TikTok/Reels style).
 * Wrapper around platform TovTalkVideoPlayer with vertical aspect ratio.
 */
@Composable
fun TovTalkReelPlayer(
    url: String,
    modifier: Modifier = Modifier,
    isPlaying: Boolean = true,
    thumbnailUrl: String? = null,
    muted: Boolean = false,
    playbackRate: Float = 1f,
    loop: Boolean = true,
    onTap: (() -> Unit)? = null,
    onVideoEnded: (() -> Unit)? = null,
    fillContainer: Boolean = false,
    nextVideoUrl: String? = null,
    onVideoReady: (() -> Unit)? = null,
    allSources: Map<String, String> = emptyMap(),
    // C8: position callbacks forwarded to platform actual
    onPositionUpdate: ((positionMs: Long, durationMs: Long) -> Unit)? = null,
    onVideoLooped: (() -> Unit)? = null,
) {
    TovTalkVideoPlayer(
        videoUrl = url,
        thumbnailUrl = thumbnailUrl,
        modifier = modifier.fillMaxSize(),
        isPlaying = isPlaying,
        isMuted = muted,
        playbackRate = playbackRate,
        loop = loop,
        onTap = onTap,
        onVideoEnded = onVideoEnded,
        aspectRatio = MediaAspectRatio.VERTICAL_VIDEO,
        fillContainer = fillContainer,
        nextVideoUrl = nextVideoUrl,
        onVideoReady = onVideoReady,
        allSources = allSources,
        onPositionUpdate = onPositionUpdate,
        onVideoLooped = onVideoLooped,
    )
}
